export enum FieldEnums {
  TEXTFIELD,
  SELECT,
  CHIP,
  CUSTOMSELECT,
  DATEPICKER,
  SUBTITLE,
}